import { useFrontendSetting } from "@faire/deprecated-retailer-visitor-shared/settings/useFrontendSetting";
import { FE_NEXTJS_PERF_APP_DISCOVER_250724 } from "@faire/retailer-settings/FE_NEXTJS_PERF_APP_DISCOVER_250724";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

import { useIsLoggedOutDiscoverPage } from "./useIsLoggedOutDiscoverPage";

export const useIsLoggedOutDiscoverPerfAppTreatment = () => {
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();

  const settingValue = useFrontendSetting(FE_NEXTJS_PERF_APP_DISCOVER_250724);

  return (
    isLoggedOutDiscoverPage && settingValue !== IThreeVariantXP.Bucket.CONTROL
  );
};
